<template>
<div>
  <wt-re-request-tip :re-load="load" v-show="loadFailed"></wt-re-request-tip>
  <pt-lab-order-detail v-loading="loading" class="pt-lab-order-detail__withData" :task="task" :statuses="statuses" :order="order" :logs="logs" :sampleRecollectLogs="sampleRecollectLogs" @on-reload="load" @handle-loding="handleLoding" :reportVisable="reportVisable" :hasSample="hasSample"></pt-lab-order-detail>
</div>
</template>
<script>
import PtLabOrderDetail from './index'
import {
  hasPermissions
} from 'utils/permissions'
export default {
  name: 'pt-lab-order-detail__withData',
  components: {
    'pt-lab-order-detail': PtLabOrderDetail
  },
  props: {
    // 路由参数 - 产品id
    id: {
      type: String,
      required: true
    },
    // 路由参数 - 产品数据，父组件可以直接传入整个产品对象绑定到详情页，也可以不传。
    value: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      // 用于绑定的产品数据对象
      order: this.value ? this.value : null,
      // 页面是否在进行数据loading
      loading: false,
      // 是否加载失败，用于显示遮罩层，用户可触发重试
      loadFailed: false,
      statuses: [],
      // 当前的异常任务
      task: null,
      relevantFiles: [],
      logs: [],
      sampleRecollectLogs: [],
      reportVisable: false,
      hasSample: false
    }
  },
  watch: {
    id (val) {
      this.load()
    }
  },
  methods: {
    getReportDetail () {
      this.loading = true
      this.$store.dispatch('ReportDetail', this.id).then((response) => {
        this.loading = false
        this.reportVisable = response.data.visible
        this.hasSample = !!response.data
      }).catch((error) => {
        this.loading = false
        console.error(error)
      })
    },
    // 加载详情数据
    load () {
      console.log('-----------------load', this.id)
      this.loading = true
      this.$store.dispatch('getLabOrderDetail', this.id).then((response) => {
        this.loadFailed = false
        this.loading = false
        let { order, status, task, logs, sampleRecollectLogs } = response
        this.order = order
        this.statuses = status
        this.task = task
        this.logs = logs
        this.sampleRecollectLogs = sampleRecollectLogs
        this.order.historyOrders = response.historyOrders
        console.log('getLabOrderthis.logs', this.order)
      }).catch((error) => {
        this.loading = false
        this.loadFailed = true
        console.error(error)
        this.$message.error(error + '获取订单信息失败！')
      })
    },
    handleLoding (val) {
      this.loading = val
    }
  },
  created () {
    if (this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions,
      'PERM_MALLSALES_ORDER_MANAGEMENT')) {
      this.getReportDetail()
    }
    // 如果父组件没有传入产品数据，则本页面根据id进行获取
    if (!this.order) {
      this.load()
    }
  }
}
</script>
